import React, { useState } from "react";
import { ArrowRight, ChevronDown } from "lucide-react";
import HeroButton from "./hero/HeroButton";
import DemoVideoModal from "./DemoVideoModal";

const bulletItems = [
  {
    title: "Excitement replaces fear",
    content: "Patients see exactly what their smile will look like after treatment",
  },
  {
    title: "Confidence replaces hesitation",
    content: "98.7% accurate AI simulations build trust in the outcome",
  },
  {
    title: "Conversations shift to \"When can we start?\"",
    content: "Patients commit faster and stop shopping on price",
  },
];

export default function GameChanger() {
  const [activeIdx, setActiveIdx] = useState(null);
  const [isDemoOpen, setIsDemoOpen] = useState(false);

  const handleToggle = (idx) => {
    setActiveIdx(activeIdx === idx ? null : idx);
  };

  return (
    <section id="solutions" className="bg-white py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-6">
        <h2 className="text-center text-3xl md:text-5xl font-bold tracking-tight text-slate-900 leading-tight">
          How AI Smile Simulation Boosts <br /> Dental Case Acceptance to 60%+
        </h2>

        <div className="mt-10 rounded-[36px] border border-slate-200 bg-white shadow-lg p-5 sm:p-7 lg:p-9">
          <h3 className="lg:hidden text-2xl sm:text-3xl font-bold tracking-tight text-slate-900 leading-tight mb-6">
            Patients Say Yes Faster with AI Smile Previews
          </h3>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-10 items-stretch">
            <div className="order-2 lg:order-1 flex flex-col justify-between">
              <div>
                <h3 className="hidden lg:block text-2xl sm:text-3xl font-bold tracking-tight text-slate-900 leading-tight">
                  Patients Say Yes Faster with AI Smile Previews
                </h3>
                <p className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed max-w-xl">
                  The moment patients see a photorealistic preview of their
                  dental implant, veneer, or All-on-X result, emotion takes over
                  and the consultation dynamic shifts.
                </p>

                <div className="mt-7 space-y-3">
                  {bulletItems.map((item, idx) => (
                    <div
                      key={idx}
                      className="group flex flex-col gap-1 rounded-2xl border border-slate-200 bg-white px-4 py-3 transition-all duration-300 hover:shadow-md cursor-pointer"
                      onMouseEnter={() => {
                        if (window.innerWidth >= 768) setActiveIdx(idx);
                      }}
                      onMouseLeave={() => {
                        if (window.innerWidth >= 768) setActiveIdx(null);
                      }}
                      onClick={() => handleToggle(idx)}
                    >
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-3">
                          <ArrowRight className="w-5 h-5 text-brand-600 shrink-0" />
                          <span className="text-slate-900 font-bold text-sm sm:text-base leading-snug">
                            {item.title}
                          </span>
                        </div>
                        <ChevronDown
                          className={`w-4 h-4 text-slate-400 transition-transform duration-300 ${activeIdx === idx ? "rotate-180 text-brand-600" : ""
                            }`}
                        />
                      </div>

                      <div
                        className={`overflow-hidden transition-all duration-300 ease-in-out ${activeIdx === idx ? "max-h-20 opacity-100 mt-2" : "max-h-0 opacity-0"
                          }`}
                      >
                        <p className="text-slate-600 text-sm sm:text-base pl-8 border-l-2 border-brand-200 ml-2.5">
                          {item.content}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="mt-8 flex flex-col sm:flex-row gap-3">
                <HeroButton href="https://app.smilereveal.io">
                  Get Started
                </HeroButton>
                <HeroButton onClick={() => setIsDemoOpen(true)} variant="secondary">
                  Watch Demo
                </HeroButton>
              </div>
            </div>

            <div className="order-1 lg:order-2 relative">
              <img
                src="/svgs/graph.svg"
                alt="Graph"
                width="600"
                height="400"
                loading="lazy"
                className=""
              />
            </div>
          </div>
        </div>
      </div>

      <DemoVideoModal isOpen={isDemoOpen} onClose={() => setIsDemoOpen(false)} />
    </section>
  );
}
